export default {
  user: JSON.parse(window.localStorage.getItem('user')) || false,
  recentClients: JSON.parse(window.localStorage.getItem('recentClients')) || false,
  rent: JSON.parse(window.localStorage.getItem('rent')) || false,
  orders: JSON.parse(window.localStorage.getItem('orders')) || false,
  unreadMessages: JSON.parse(window.localStorage.getItem('unreadMessages')) || false,
  notificationsPanel: JSON.parse(window.localStorage.getItem('notificationsPanel')) || false,
  notifictionsGeneral: JSON.parse(window.localStorage.getItem('notifictionsGeneral')) || 0,
  notifications: JSON.parse(window.localStorage.getItem('notifications')) || [],
  openedOnManagementSite: JSON.parse(window.localStorage.getItem('configModalReviewsClient')) || false,
  newClients: JSON.parse(window.localStorage.getItem('newClients')) || false,
  photosNotificationClients: JSON.parse(window.localStorage.getItem('photosNotification')) || []
}



// WEBPACK FOOTER //
// ./src/store/state.js